"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgOpenBlank = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "m18.865 1.7145h-17.149v17.155m0-17.155 20.579 20.586z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 3.4304 }))));
exports.default = SvgOpenBlank;
//# sourceMappingURL=OpenBlank.js.map